import {
  Box,
  Container,
  Stack,
  Text,
  Input,
  Image,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import Seo from "../../utils/Seo/";

export default function Footer() {
  return (
    <>
      <Seo />
      <Box
        bg={useColorModeValue("gray.50", "gray.900")}
        color={useColorModeValue("gray.700", "gray.200")}
      >
        <Container
          as={Stack}
          maxW={"6xl"}
          py={4}
          direction={{ base: "column", md: "row" }}
          spacing={4}
          justify={{ base: "center", md: "space-between" }}
          align={{ base: "center", md: "center" }}
        >
          <Text>© 2024 Ayush Sharma</Text>
          <Text padding={"2px"}>Made with 💖,☕&🥤by Ayush</Text>

          {/* <Stack align={"flex-end"}>
            <Stack direction={" row"}>
              <Input
                placeholder={"Get Updates"}
                bg={useColorModeValue("blackA1pha.100 ", "whiteA1pha.100 ")}
                border={0}
                _focus={{
                  bg: "whiteA1pha. 300",
                }}
              />
              <IconButton
                bg={useColorModeValue(" green .400 ", "green.800")}
                color={useColorModeValue("white ", "gray.800")}
                _hover={{
                  bg: " green. 600",
                }}
                aria-label=" Subscribe "
                icon={"s"}
              />
            </Stack>
          </Stack> */}

          <Box>
            <Image
              src={
                "https://wakatime.com/badge/user/303a8372-abc8-4047-8f4a-be886b6c9a64/project/10bd15c3-b75a-4ec7-a8a2-bcb92c3624f1.svg"
              }
            ></Image>
            <Image
              src={
                "https://wakatime.com/badge/user/303a8372-abc8-4047-8f4a-be886b6c9a64/project/0316d651-40f5-4aca-b692-eb9ddafc9264.svg"
              }
            ></Image>

            <Image
              src={
                "https://wakatime.com/badge/user/62850a07-caf8-470f-86a7-660093b4f5b4/project/018e65ba-8390-4f2f-b504-014368cd620e.svg"
              }
            ></Image>
            <Image
              src={
                "https://wakatime.com/badge/user/62850a07-caf8-470f-86a7-660093b4f5b4/project/a0725d5b-0d43-4ad9-8709-4e689e5ea9c5.svg"
              }
            ></Image>
          </Box>
        </Container>
      </Box>
    </>
  );
}
